import { render, staticRenderFns } from "./annualStatistics.vue?vue&type=template&id=215ee87b&scoped=true&"
import script from "./annualStatistics.vue?vue&type=script&lang=js&"
export * from "./annualStatistics.vue?vue&type=script&lang=js&"
import style0 from "./annualStatistics.vue?vue&type=style&index=0&id=215ee87b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ee87b",
  null
  
)

export default component.exports